// import Post from '../../libs/request/post'
import Get from '../../libs/request/get'
import data from '../../const'
const state = {
  channelData: {},
  isLoading: false
}
const getters = {
  getChannelData: state => state.channelData,
  getLoading: state => state.isLoading
}

const mutations = {
  setChannelData (state, channelData) { state.channelData = channelData },
  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}
const actions = {
  // async [types.getBanners] ({commit}, data) {
  //
  //   // commit('setBanners',)
  // }
  getRateByProductCode ({commit}) {
    commit('setLoading', true)
    Get.getProductRate().then((res) => {
      if (res) {
        if (res.code === 0) {
          commit('setLoading', false)
          if (res.data.payType === data.chargeType.byTime) {
            res.data.payTypeText = res.data.price + '元/分钟'
          } else {
            res.data.payTypeText = res.data.price + '元/次'
          }
          commit('setChannelData', res.data)
        }
      }
    })
  }

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}

export {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/product.js